import { useCMSContent } from "../../hooks/useCMSContent";
import { usePricing } from "../../context/PricingContext";
import { useI18n } from "../../i18n";
import { CreditCard, QrCode, BellRing } from "lucide-react";

const STEP_ICONS = [CreditCard, QrCode, BellRing];

const HowItWorks = () => {
  const { data: cms } = useCMSContent("landing_json");
  const { localizeText } = usePricing();
  const { t } = useI18n();
  const c = cms?.how_it_works || {
    title: "¿Cómo funciona?",
    subtitle: "Solo 3 pasos para proteger lo que más te importa",
    step_1_title: "Activa tu membresía",
    step_1_text: "Elige el plan que te convenga; el cobro se hace en soles (PEN).",
    step_2_title: "Coloca tu QR",
    step_2_text: "En tu auto, collar de mascota o mochila.",
    step_3_title: "Recibe avisos privados",
    step_3_text: "Sin mostrar tu número.",
  };

  const steps = [
    { n: 1, title: c.step_1_title, text: localizeText(c.step_1_text) },
    { n: 2, title: c.step_2_title, text: c.step_2_text },
    { n: 3, title: c.step_3_title, text: c.step_3_text },
  ];

  return (
    <section id="como-funciona" className="bg-white py-20 md:py-28" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 max-w-2xl">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-[#1B84FF]">
            {t("how.eyebrow")}
          </p>
          <h2
            className="mb-4 text-3xl font-extrabold tracking-tight text-[#0B2545] sm:text-4xl lg:text-5xl"
            data-testid="how-title"
          >
            {c.title}
          </h2>
          <p className="text-base text-slate-600 md:text-lg" data-testid="how-subtitle">{c.subtitle}</p>
        </div>

        <ol className="relative grid gap-8 md:grid-cols-3 md:gap-6">
          <div
            className="absolute left-0 right-0 top-[2.75rem] hidden h-px bg-gradient-to-r from-[#1B84FF]/0 via-[#1B84FF]/40 to-[#1B84FF]/0 md:block"
            aria-hidden="true"
          />
          {steps.map((s, i) => {
            const Icon = STEP_ICONS[i];
            return (
              <li
                key={s.n}
                className="relative rounded-3xl border border-slate-200/80 bg-white p-7 shadow-[0_8px_30px_rgba(11,37,69,0.05)] transition-transform duration-300 hover:-translate-y-1"
                data-testid={`how-step-${s.n}`}
              >
                <div className="mb-6 flex items-center gap-4">
                  <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#0B2545] text-white shadow-[0_10px_24px_rgba(11,37,69,0.25)]">
                    <Icon className="h-6 w-6" />
                  </span>
                  <span className="text-5xl font-extrabold leading-none text-[#1B84FF]/15">
                    0{s.n}
                  </span>
                </div>
                <h3 className="mb-2 text-xl font-bold text-[#0B2545]" data-testid={`how-step-${s.n}-title`}>
                  {s.title}
                </h3>
                <p className="text-slate-600" data-testid={`how-step-${s.n}-text`}>{s.text}</p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorks;
